import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";


// UrlApi: "https://hlg-ecommerce-vip-api.primecase.com.br/api",

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "Luminacorretora",
  UserStorage: "X8c8e5km7ZNW4itWjB9sk0==",
  UserToken: "H2cmV9zZ8ZGeQhy1dvrA5z==",
  UrlApi: "https://prd-ecommerce-api.primecase.com.br/api",
  UrlLoja:"https://vipscorretoradecambio.com.br",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",

  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#4c7a41",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("#4c7a41", 10), // Escurece em 20%
    },
    secondary: {
      main: "#7E7296",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
